const config = {
	pageSize: 25,
	pageName: "CompanyGoalsList",
	baseURL: "/company/goals/list",
	goalURL: "/goal/",
};

export default config;
